import { isBrowser } from './env';

export * from './loadScript';
export { default as http } from './http';

export function parseQuery(): { [key: string]: any } {
  const { search } = location;
  const r = /([^=&?#]+)=([^&#]*)/g;
  const matches = search.match(r);
  if (!matches || !matches.length) {
    return {};
  }
  const query = {};
  matches.forEach(str => {
    const idx = str.indexOf('=');
    query[str.substr(0, idx)] = decodeURIComponent(str.substr(idx + 1));
  });
  return query;
}

export const isSandbox = () => {
  if (!isBrowser) {
    return false;
  }

  const { hostname } = location;

  return (
    hostname.includes('.bytedance.net') || hostname === 'act-sandbox.snssdk.com'
  );
};
